import { fad } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { PivotColsDialog } from './PivotColsDialog';

export const PivotColsButton = ({ columns, rows, value, setPivotCols }) => {

  const { openDialog } = useDialog();

  const openPivotColsDialog = () => {
    openDialog(PivotColsDialog, { columns, rows, value }).then((result) => {
      if (!result) return;
      setPivotCols(result.columns, result.rows, result.value);
    });
  }

  return (
    <TitleButton
      dataTestId="pivot-cols-button"
      icon={fad.faLayerGroup}
      toolTip="Select Columns to Pivot"
      onClick={openPivotColsDialog}
    />
  )
}